import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProntuarioService {
  private readonly IdKey = 'id';

  constructor() { 
    var stored = localStorage.getItem(this.IdKey);
    if (stored) {
      this.id = stored;
    }
  }

  private _id: string = '';

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
    localStorage.setItem(this.IdKey, value);
  }

  clearId(): void {
    this._id = '';
    localStorage.removeItem(this.IdKey);
  }

  getId(): string {
    if (!this._id) {
      const stored = localStorage.getItem(this.IdKey);
      if (stored) {
        this._id = stored;
      } else {
        return null;
      }
    }
    return this._id;
  }
}
